export default "__VITE_ASSET__V0jEPBLf__"